import { BASE_CLASS_PREFIX } from '../base/constants';

const cssClasses = {
    PREFIX: `${BASE_CLASS_PREFIX}-breadcrumb`,
};

const strings = {
    MORE_TYPE: ['default', 'popover'],
};

export { cssClasses, strings };
